/*
 * HomePage Messages
 *
 * This contains all the text for the HomePage container.
 */

import { defineMessages } from 'react-intl';

export const scope = 'features.HomePage';

export default defineMessages({
  title: {
    id: `${scope}.title`,
    defaultMessage: 'Personal Start Page',
  },
  createAccessCode: {
    id: `${scope}.createAccessCode`,
    defaultMessage: 'Create Access Code',
  },
  spaceInvitations: {
    id: `${scope}.spaceInvitations`,
    defaultMessage: 'Space Invitations',
  },
  space: {
    id: `${scope}.space`,
    defaultMessage: 'Space',
  },
  invitedBy: {
    id: `${scope}.invitedBy`,
    defaultMessage: 'Invited by',
  },
  email: {
    id: `${scope}.email`,
    defaultMessage: 'Email',
  },
  phone: {
    id: `${scope}.phone`,
    defaultMessage: 'Phone',
  },
  date: {
    id: `${scope}.date`,
    defaultMessage: 'Date',
  },
  role: {
    id: `${scope}.role`,
    defaultMessage: 'Role',
  },
  spaceMemberships: {
    id: `${scope}.spaceMemberships`,
    defaultMessage: 'Space Memberships',
  },
  enrolledBy: {
    id: `${scope}.enrolledBy`,
    defaultMessage: 'Enrolled by',
  },
  startDate: {
    id: `${scope}.startDate`,
    defaultMessage: 'Start date',
  },
  achievementsConfirmReqs: {
    id: `${scope}.achievementsConfirmReqs`,
    defaultMessage: 'Achievements Confirmation Requests',
  },
  from: {
    id: `${scope}.from`,
    defaultMessage: 'From',
  },
  event: {
    id: `${scope}.event`,
    defaultMessage: 'Event',
  },
  condition: {
    id: `${scope}.condition`,
    defaultMessage: 'Condition',
  },
  result: {
    id: `${scope}.result`,
    defaultMessage: 'Result',
  },
  endDate: {
    id: `${scope}.endDate`,
    defaultMessage: 'End Date',
  },
  questinnaires: {
    id: `${scope}.questinnaires`,
    defaultMessage: 'Questionnaires',
  },
  questionnaire: {
    id: `${scope}.questionnaire`,
    defaultMessage: 'Questionnaire',
  },
  sentBy: {
    id: `${scope}.sentBy`,
    defaultMessage: 'Sent by',
  },
  requestDate: {
    id: `${scope}.requestDate`,
    defaultMessage: 'Request date',
  },
  completedDate: {
    id: `${scope}.completedDate`,
    defaultMessage: 'Completed date',
  },
  member: {
    id: `${scope}.member`,
    defaultMessage: 'Member',
  },
  admin: {
    id: `${scope}.admin`,
    defaultMessage: 'Space Administrator',
  },
  spaceOwner: {
    id: `${scope}.spaceOwner`,
    defaultMessage: 'Space Owner',
  },
  open: {
    id: `${scope}.open`,
    defaultMessage: 'Open',
  },
  completed: {
    id: `${scope}.completed`,
    defaultMessage: 'Completed',
  },
  leaveSpace: {
    id: `${scope}.leaveSpace`,
    defaultMessage: 'Are you sure you want to leave space?',
  },
  confirmAchievement: {
    id: `${scope}.confirmAchievement`,
    defaultMessage: 'Are you sure you want to confirm this Achievement?',
  },
  declineAchievement: {
    id: `${scope}.declineAchievement`,
    defaultMessage: 'Are you sure you want to decline this Achievement?',
  },
  acceptInvitation: {
    id: `${scope}.acceptInvitation`,
    defaultMessage: 'Accept Invitation',
  },
  declineInvitation: {
    id: `${scope}.declineInvitation`,
    defaultMessage: 'Decline Invitation',
  },
  acceptAchievement: {
    id: `${scope}.acceptAchievement`,
    defaultMessage: 'Accept Achievement',
  },
  declineAchievementBtn: {
    id: `${scope}.declineAchievement`,
    defaultMessage: 'Decline Achievement',
  },
  leaveFromSpace: {
    id: `${scope}.leaveFromSpace`,
    defaultMessage: 'Leave from space',
  },
});
